import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';
import { withLoaderFactory } from '@mews/framework';

interface PageLoaderStore {
    loaderVisible: boolean;
    showPageLoader: () => void;
    hidePageLoader: () => void;
}

export const pageLoaderStore = createStore<PageLoaderStore>((set) => ({
    loaderVisible: false,
    showPageLoader: () => set({ loaderVisible: true }),
    hidePageLoader: () => set({ loaderVisible: false }),
}));

/**
 * @deprecated do not use in new code
 * It's meant only as a replacement for existing logic in modal manager
 * */
export const { showPageLoader, hidePageLoader } = pageLoaderStore.getState();

export const getLoaderVisible = () => pageLoaderStore.getState().loaderVisible;

export const useLoaderVisible = () => useStore(pageLoaderStore, (store) => store.loaderVisible);

const withLoader = withLoaderFactory(showPageLoader, hidePageLoader);
/**
 * @deprecated do not use in new code
 */
export const withActiveWindowLoader = async <T>(callback: () => T) => withLoader(callback);
